module.exports = __webpack_public_path__ + "img/icon_证书_A级赛事@2x.6e620f3c.png";